<script>
export default {
  name: 'DeliveryPanel',
  computed: {
    deliveryDate () {
      const today = new Date()
      const futureDate = new Date(today)
      futureDate.setDate(today.getDate() + 7);
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }
      const formatter = new Intl.DateTimeFormat('fr-FR', options);
      let formattedDate = formatter.format(futureDate);
      return formattedDate.replace(", ", " à ");
    }
  }
}
</script>

<template>
  <div class="space-y-4">
    <h3 class="text-xl font-semibold text-gray-900 dark:text-white">Livraison</h3>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 ps-4 dark:border-gray-700 dark:bg-gray-800">
        <div class="flex items-start">
          <div class="flex h-5 items-center">
            <input id="fedex" checked aria-describedby="fedex-text" type="radio" name="delivery-method" value="" class="h-4 w-4 border-gray-300 bg-white text-primary-700 focus:ring-2 focus:ring-primary-700" />
          </div>

          <div class="ms-4 text-sm">
            <label for="fedex" class="font-medium leading-none text-gray-900 dark:text-white"> Livraison gratuite - Chronopost </label>
            <p id="fedex-text" class="mt-1 text-xs font-normal text-gray-500 dark:text-gray-400">
              <span class="capitalize">éstimé le </span> {{ deliveryDate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>